// Human summary of a per-system VAI commit result. The commit has REPLACE
// semantics (the system's existing Excel/manual rows are deleted before the
// insert), so the toast must say so — never "duplicates skipped" as if the
// upload merely deduped when existing data was actually replaced.
export function vaiReplaceSummary(deleted: number, inserted: number, skipped: number): string {
  const base = deleted > 0
    ? `replaced ${deleted} existing row${deleted !== 1 ? 's' : ''} with ${inserted}`
    : `${inserted} row${inserted !== 1 ? 's' : ''} added`
  return skipped > 0
    ? `${base} (${skipped} skipped: duplicate item no. or Word-RA row)`
    : base
}
